import script from "./CompanyProfileTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyProfileTab.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyProfileTab.vue?vue&type=style&index=0&id=2c2e903b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2e903b"]])

export default __exports__